import { Button, ButtonProps } from '@chakra-ui/react';
import { forwardRef, type ReactNode } from 'react';

interface FilterPillProps extends ButtonProps {
  selected?: boolean;
  children: ReactNode;
}

export const FILTER_CONTROL_STYLE = {
  h: '36px',
  px: '2.5',
  borderRadius: '10px',
  fontSize: '0.8125rem',
  lineHeight: '20px',
  fontWeight: '500',
  flexShrink: 0,
} as const;

export const FilterPill = forwardRef<HTMLButtonElement, FilterPillProps>(function FilterPill(
  { selected = false, children, ...props },
  ref
) {
  return (
    <Button
      ref={ref}
      size="xs"
      variant="ghost"
      layerStyle="filterPill"
      bg={selected ? 'ui.surface.selected' : undefined}
      borderColor={selected ? 'ui.border.accent' : undefined}
      color={selected ? 'ui.text.accent' : undefined}
      {...FILTER_CONTROL_STYLE}
      {...props}
    >
      {children}
    </Button>
  );
});
